import { render, staticRenderFns } from "./ColorDialog.vue?vue&type=template&id=8dd69e48&scoped=true&"
import script from "./ColorDialog.vue?vue&type=script&lang=js&"
export * from "./ColorDialog.vue?vue&type=script&lang=js&"
import style0 from "./ColorDialog.vue?vue&type=style&index=0&id=8dd69e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd69e48",
  null
  
)

export default component.exports